module.exports = __webpack_public_path__ + "static/media/circle.982238fb.svg";